export const truncateText = (text, max = 15) => {
  if (text === null || text === undefined) return "";
  const value = String(text);
  return value.length > max ? `${value.slice(0, max)}...` : value;
};

export const truncateHtml = (html, max = 15) => {
  if (!html) return "";
  const text = String(html)
    .replace(/<[^>]*>/g, "")
    .trim();
  return truncateText(text, max);
};

export const buildPageItems = (page, totalPages) => {
  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, index) => index);
  }

  const items = [];
  const addPage = (pageIndex) => {
    if (pageIndex < 0 || pageIndex >= totalPages) return;
    if (!items.includes(pageIndex)) items.push(pageIndex);
  };

  addPage(0);
  addPage(page - 1);
  addPage(page);
  addPage(page + 1);
  addPage(totalPages - 1);

  const sorted = items.sort((a, b) => a - b);
  const withEllipsis = [];

  sorted.forEach((pageIndex, index) => {
    if (index > 0 && pageIndex - sorted[index - 1] > 1) {
      withEllipsis.push("ellipsis");
    }
    withEllipsis.push(pageIndex);
  });

  return withEllipsis;
};
